import React from "react";

import './services.css';
import Kartu from "./card/card";

function Services() {
    
    const service = [
        {
            name: 'Engine',
            jasa: ['Check', 'Tune Up', 'Full / Semi overhaul', 'Spark plug service / change'],
            img: require('../../photo/m4engine.jpg')
        },
        {
            name: 'ECU',
            jasa: ['Remap', 'Check', 'Setup', 'Reset', 'Scan'],
            img: require('../../photo/IMG-0695.jpg')
        },
        {
            name: 'Suspension',
            jasa: ['Adjustment', 'Installment'],
            img: require('../../photo/IMG-0692.jpg'),
        },
        {
            name: 'Electronics',
            jasa: ['Check', 'Headlamp service and replacement', 'Brake lamp service and replacement', 'Wiring check and overhaul / replacement', 'Modification (Light bulb change)'],
            img: require('../../photo/IMG-0694.jpg')
        },
        {
            name: 'Braking',
            jasa: ['Check', 'Service & overhaul', 'Flush brake fluid', 'Brake pads (replace / service)', 'Disc brake (replace / service)', 'Brake caliper (replace / service)'],
            img: require('../../photo/IMG-0690.jpg')
        },
        {
            name: 'Transmission',
            jasa: ['Check', 'Service & overhaul', 'Modification', 'Transmission oil change'],
            img: require('../../photo/IMG-0697.jpg')
        },
        {
            name: 'Dyno & Dastek Unichip',
            jasa: ['Remap', 'Unichip installment', 'Run', 'Tuning'],
            img: require('../../photo/IMG-0173.jpg')
        },
        {
            name: 'Steering',
            jasa: ['Check', 'Spooring & Balancing', 'Service', 'Overhaul', 'Power steering oil change'],
            img: require('../../photo/IMG-0691.jpg')
        },
        {
            name: 'Products we use',
            jasa: ['In collaboration with 77 Lubricants', 'Brake Fluids: Brembo, Total, Motul', 'Spark Plugs: NGK, Denso', 'Brake Pads: Ferodo, Mintye', 'Carbon Clean: Kohzai, Liqui Moly, Engine Flush Plus', 'Engine Oil: 77, Aral, Motul, Mobil 1', 'Transmission Fluid: TMO, Total, Aral, 77'],
            img: require('../../photo/77-lub.jpg')
        },
        {
            name: 'Other services',
            jasa: ['Oil change', 'Fuel filter change', 'Oil filter change', 'Air filter change', 'Intake manifold', 'Carbon clean', 'Diesel purge', 'Injector', 'Towing'],
            img: require('../../photo/IMG-0634.jpg')
        }
    ]

    return (
        <div id="ser">
            <div className="d-flex justify-content-center mt-5">
                <h2>What we do <i class="bi bi-wrench-adjustable-circle" style={{ fontSize: '29px' }}></i></h2>
            </div>
            <div className="drops">
                <div className="grid mt-5">

                    <div style={{ maxWidth: '1200px' }}>
                        <h4 className="svc-info">We offer a wide range of service related to repairs, maintenance and modification. We welcome brands from any region and provide a wide list of spare part brands to ensure maximum performance.</h4>
                        <h4 className="svc-info">These are the list of services we do, regarding the pricing and more enquiries please do not hesitate to contact us and we will reply as soon as we can. It is advised to communicate with us in advance before coming.</h4>
                    </div>

                    {service.map((svc, index) => (
                        <Kartu
                            key={index}
                            services={svc}
                        />
                    ))}
                </div>
            </div>
        </div>
    )
};

export default Services;